import React, { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const Table: FC<Props> = ({ children }) => {
  return (
    <div className="table-responsive">
      <table
        className="table table-striped rounded-4"
        style={{ border: "1px solid #EAECF0" }}
      >
        {children}
      </table>
    </div>
  );
};


